// extracted by mini-css-extract-plugin
export var divider = "_jm-7";
export var itemsToggle = "_jm-8";
export var mergeModal = "_jm-1";
export var optionCard = "_jm-4";
export var radioGroup = "_jm-6";
export var radioOption = "_jm-0";
export var selected = "_jm-5";
export var shipmentOptions = "_jm-2";
export var tableOptions = "_jm-3";